module.exports = __webpack_public_path__ + "img/option-1-icon.194aefb9.png";